'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];

    for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }

  return target;
};

var _createClass = function () {
  function defineProperties(target, props) {
    for (var i = 0; i < props.length; i++) {
      var descriptor = props[i];
      descriptor.enumerable = descriptor.enumerable || false;
      descriptor.configurable = true;
      if ("value" in descriptor) descriptor.writable = true;
      Object.defineProperty(target, descriptor.key, descriptor);
    }
  }

  return function (Constructor, protoProps, staticProps) {
    if (protoProps) defineProperties(Constructor.prototype, protoProps);
    if (staticProps) defineProperties(Constructor, staticProps);
    return Constructor;
  };
}();

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _Switch = require('../Switch/Switch');

var _Switch2 = _interopRequireDefault(_Switch);

var _Container = require('./components/Container');

var _Container2 = _interopRequireDefault(_Container);

var _SwitchContainer = require('./components/SwitchContainer');

var _SwitchContainer2 = _interopRequireDefault(_SwitchContainer);

var _SwitchCol = require('./components/SwitchCol');

var _SwitchCol2 = _interopRequireDefault(_SwitchCol);

var _Header = require('./components/Header');

var _Header2 = _interopRequireDefault(_Header);

var _days = require('./days');

var _days2 = _interopRequireDefault(_days);

var _hours = require('./hours');

var _hours2 = _interopRequireDefault(_hours);

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

function _toConsumableArray(arr) {
  if (Array.isArray(arr)) {
    for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) {
      arr2[i] = arr[i];
    }

    return arr2;
  } else {
    return Array.from(arr);
  }
}

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _possibleConstructorReturn(self, call) {
  if (!self) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return call && (typeof call === "object" || typeof call === "function") ? call : self;
}

function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
  }

  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      enumerable: false,
      writable: true,
      configurable: true
    }
  });
  if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
} // Components
// Options


var SimpleScheduler = function (_Component) {
  _inherits(SimpleScheduler, _Component);

  function SimpleScheduler() {
    var _ref;

    var _temp, _this, _ret;

    _classCallCheck(this, SimpleScheduler);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = SimpleScheduler.__proto__ || Object.getPrototypeOf(SimpleScheduler)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
      days: [],
      hours: []
    }, _this.onChange = function (value, key) {
      return function () {
        var _this$props = _this.props,
            disabled = _this$props.disabled,
            onChange = _this$props.onChange;
        if (disabled) return;
        var values = [].concat(_toConsumableArray(_this.state[key]));

        var state = _extends({}, _this.state);

        state[key] = values.includes(value) ? [].concat(_toConsumableArray(values)).filter(function (v) {
          return v !== value;
        }) : [].concat(_toConsumableArray(values), [value]);

        _this.setState(state);

        var days = [].concat(_toConsumableArray(_days2.default)).filter(function (_ref2) {
          var value = _ref2.value;
          return state.days.includes(value);
        }).map(function (_ref3) {
          var value = _ref3.value;
          return value;
        });
        var hours = [].concat(_toConsumableArray(_hours2.default)).filter(function (_ref4) {
          var value = _ref4.value;
          return state.hours.includes(value);
        }).map(function (_ref5) {
          var value = _ref5.value;
          return value;
        });
        onChange(!days.length && !hours.length ? null : '* * ' + (!!hours.length ? hours.join(',') : '*') + ' * * ' + (!!days.length ? days.join(',') : '*'));
      };
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  _createClass(SimpleScheduler, [{
    key: 'render',
    value: function render() {
      var _this2 = this;

      var _props = this.props,
          dayLabel = _props.dayLabel,
          hourLabel = _props.hourLabel;
      var _state = this.state,
          days = _state.days,
          hours = _state.hours;
      return _react2.default.createElement(_Container2.default, null, _react2.default.createElement(_Header2.default, null, dayLabel), _react2.default.createElement(_SwitchContainer2.default, null, _days2.default.map(function (day) {
        return _react2.default.createElement(_SwitchCol2.default, {
          key: day.value
        }, _react2.default.createElement(_Switch2.default, {
          value: days.includes(day.value),
          onChange: _this2.onChange(day.value, 'days')
        }, day.label));
      })), _react2.default.createElement(_Header2.default, null, hourLabel), _react2.default.createElement(_SwitchContainer2.default, null, _hours2.default.map(function (hour) {
        return _react2.default.createElement(_SwitchCol2.default, {
          key: hour.value
        }, _react2.default.createElement(_Switch2.default, {
          value: hours.includes(hour.value),
          onChange: _this2.onChange(hour.value, 'hours')
        }, hour.label));
      })));
    }
  }]);

  return SimpleScheduler;
}(_react.Component);

SimpleScheduler.propTypes = {
  disabled: _propTypes2.default.bool,
  dayLabel: _propTypes2.default.node,
  hourLabel: _propTypes2.default.node,
  onChange: _propTypes2.default.func.isRequired
};
SimpleScheduler.defaultProps = {
  dayLabel: 'Days',
  hourLabel: 'Hours'
};
exports.default = SimpleScheduler;